import 'jquery';
import HtmlElement from './HtmlElement';

/**
 * Form
 *
 * @return Array
 */
const Form = (($) => {
  /**
   *  Fields
   *
   *  @var { Array }
   */
  const Fields = [
    'input:not([type="checkbox"]:not([type="radio"]))',
    'select',
    'textarea'
  ];

  /**
   * Selector
   *
   * @var { Object }
   */
  const Selector = {
    FORM: 'form',
    INPUT_WRAP: '.input-wrap',
    MORE_FIELDS: '.form-more-fields',
    MORE_FIELDS_BUTTON: '.form-show-more-fields'
  };

  /**
   * ClassName
   *
   * @var { Object }
   */
  const ClassName = {
    FORM_CUSTOM: 'form-custom',
    FIELD_FOCUSED: 'field-focused',
    FIELD_HAS_VALUE: 'field-has-value'
  };

  /**
   * Form
   *
   * @class
   * @augments HtmlElement
   */
  class Form extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      this._$fields = this.$element.find(Fields.join());

      this._bindHandlers();
      this._initializeDatepicker();
      this._initializeContactOptions();
    }

    // Private

    /**
     * Binds event handlers to the elements
     *
     * @return void
     */
    _bindHandlers() {
      if (this.$element.hasClass(ClassName.FORM_CUSTOM)) {
        this._$fields.each((i, field) => {
          let $field = $(field);

          this._fieldHandleInput($field);

          $field.on('focus', () => {
            this._fieldFocus($field);
          });

          $field.on('blur', () => {
            this._fieldBlur($field);
          });

          $field.on('input change', () => {
            this._fieldHandleInput($field);
          });

          try {
          	  // autfill is not supported by eg. firefox: https://caniuse.com/?search=autofill
			  if ($field.is(':-webkit-autofill')) {
				  this._fieldHandleInput($field);
			  }
		  } catch(e){
          	// do nothing
		  }

			$field.on('invalid', () => {
				const $firstInvalid = this.$element.find(':invalid').first();
				const offset = $firstInvalid.offset().top - $('#header').outerHeight();
				$('html,body').scrollTop(offset);
			});
        });
      }

      // Add more fields handling if available
      let $moreFieldsButton = this.$element.find(Selector.MORE_FIELDS_BUTTON),
          $moreFields = this.$element.find(Selector.MORE_FIELDS);

      if ($moreFieldsButton.length > 0) {
        $moreFieldsButton.on('click', (e) => {
          $moreFields.css({
            'height': 'auto',
            'display': 'none',
            'visibility': 'visible'
          });
          $moreFields.slideDown({
            duration: 300,
            progress: () => {
              $moreFields.parents('[data-equalizer]').each((i, el) => {
                new Foundation.Equalizer($(el)).applyHeight();
              });
            }
          });
          $(e.currentTarget).remove();
        });
      }
    }

    /**
     * Initializes the datepicker
     *
     * @return void
     */
    _initializeDatepicker() {
      this.$element.find('input[type="text"]').each((i, field) => {
        let $field = $(field),
          $inputWrap = $field.parent(Selector.INPUT_WRAP);

        if ($inputWrap.hasClass('datepicker')) {
          $field.datepicker({
            dateFormat: 'dd.mm.yy',
            showAnim: 'fadeIn',
            showOtherMonths: true,
            selectOtherMonths: true
          });

          $field.datepicker('option', $.datepicker.regional['de']);
          $field.datepicker('option', {
            prevText: '<i class="fa fa-angle-left"></i>',
            nextText: '<i class="fa fa-angle-right"></i>'
          });
        }
      });
    }

    /**
     * Initializes the contact options
     * NOTE: The "phone" option must be the first one. Otherwise the "required" toggling function won't work anymore.
     *
     * @return void
     */
    _initializeContactOptions() {
      let $contactOptions = this.$element.find('[id*="-contactOptions"]'),
          $phone = this.$element.find('[id*="-phone"]');

      if ($contactOptions.length > 0 && $phone.length > 0) {
        let $firstOptionLabel = $contactOptions.find('.custom-field-checkbox').first(),
            $phoneLabel = $phone.prev('label'),
            phoneLabelText = $phoneLabel.html();

        $firstOptionLabel.find('> input[type="checkbox"]').on('change', (e) => {
          if ($(e.target).prop('checked') === true) {
            $phone.attr('required', 'required');
            $phoneLabel.html(`${phoneLabelText}*`);
          } else {
            $phone.removeAttr('required');
            $phoneLabel.html(phoneLabelText);
          }
        });
      }
    }

    /**
     * Handles focus of the given field
     *
     * @param { jQuery } $field
     * @return void
     */
    _fieldFocus($field) {
      $field.parent(Selector.INPUT_WRAP).addClass(ClassName.FIELD_FOCUSED);
    }

    /**
     * Handles blur of the given field
     *
     * @param { jQuery } $field
     * @return void
     */
    _fieldBlur($field) {
      $field.parent(Selector.INPUT_WRAP).removeClass(ClassName.FIELD_FOCUSED);
    }

    /**
     * Handles input of the given field
     *
     * @param { jQuery } $field
     * @return void
     */
    _fieldHandleInput($field) {
      if ($field.val() !== '') {
        $field.parent(Selector.INPUT_WRAP).addClass(ClassName.FIELD_HAS_VALUE);
      } else {
        $field.parent(Selector.INPUT_WRAP).removeClass(ClassName.FIELD_HAS_VALUE);
      }
    }
  }

  return Form._getElements(Selector.FORM, Form);
})(jQuery);

export default Form;
